import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface ModernHeaderProps {
  transparent?: boolean;
}

const ModernHeader: React.FC<ModernHeaderProps> = ({ transparent = true }) => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  // Animation variants
  const navbarVariants = {
    transparent: { 
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(5px)',
      boxShadow: 'none'
    },
    solid: { 
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    }
  };

  return (
    <>
      <motion.header
        className={`fixed w-full z-50 transition-all duration-300`}
        initial="transparent"
        animate={isScrolled || !transparent ? "solid" : "transparent"}
        variants={navbarVariants}
      >
        <div className="container mx-auto px-4 py-4 max-w-7xl">
          <div className="flex items-center justify-between md:justify-between">
            {/* Logo - centered on mobile, left-aligned on desktop */}
            <Link to="/" className="flex items-center space-x-2 md:flex-none flex-1 justify-center md:justify-start">
              <img 
                src="/logo.png" 
                alt="Nemlingo" 
                className="h-20 w-auto"
              />
            </Link>

            {/* CTA Button */}
            <div className="hidden md:flex">
              <Link to="/download">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                  className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-full font-medium shadow-md transition-colors duration-300"
                >
                  {t('nav.download', 'Download')}
                </motion.button>
              </Link>
            </div>
          </div>
        </div>
      </motion.header>
      
      {/* Spacer for fixed header */}
      <div className="h-16"></div>
    </>
  );
};

export default ModernHeader;
